fx.ns("shared.popups", class SaveBookError extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );

        this.contentWidth = 550;
        this.contentHeight = 225;
    }

    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:fx.text("Je n'arrive pas à sauvegarder votre création"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("J'ai rencontré un problème lors de la sauvegarde de votre création. Veuillez-ressayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>."), className:"text center"}));

        this.okButton = new fx.components.Button({label : fx.text("Ré-essayer"), type : "filled"});
        this.cancelButton = new fx.components.Button({label : fx.text("Fermer")});
        
        this.addFooterChild(this.cancelButton, {width : 200});
        this.addFooterChild(this.okButton, {width : 200});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onRetry, this.okButton);
        this.on("click", this.onClose, this.cancelButton);
    }

    onRetry()
    {
        this.close();
        this.data.event("exit-editor"); // TODO : lastAction on main
    }

    onClose()
    {
        this.close();
        this.data.event("show-editor");
    }
});